import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({ components: {} })
export default class SectionTitle extends Vue {
  @Prop() public title!: string;
  @Prop({ default: false }) public first!: boolean;
}
